import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function Header() {
  return <header className="w-full bg-white border-b border-[#E0E0E0] border-t-4 border-t-[#1B5E20]" data-id="element-23">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-24">
        <div className="flex items-center gap-2 cursor-pointer" data-id="element-25">
          <BookOpenIcon className="w-6 h-6 text-[#2E7D32]" data-id="element-26" />
          <span className="text-xl font-serif font-bold text-[#1B5E20]" data-id="element-27">
            EvidentiaMed
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-6" data-id="element-28">
          <a href="#" className="text-sm font-medium text-gray-600 hover:text-[#2E7D32] transition-colors" data-id="element-29">
            Home
          </a>
          <a href="#" className="text-sm font-medium text-gray-600 hover:text-[#2E7D32] transition-colors" data-id="element-30">
            Browse
          </a>
          <a href="#" className="text-sm font-medium text-[#2E7D32] border-b-2 border-[#2E7D32] pb-1" data-id="element-31">
            Authors
          </a>
          <a href="#" className="text-sm font-medium text-gray-600 hover:text-[#2E7D32] transition-colors" data-id="element-32">
            About
          </a>
          <a href="#" className="text-sm font-medium text-gray-600 hover:text-[#2E7D32] transition-colors" data-id="element-33">
            Help
          </a>
        </nav>
      </div>
    </header>;
}